import type { FC, ReactNode } from "react";
import { useAuth }     from "./AuthContext";
import { LoginPage }   from "../components/auth/LoginPage";

export const AuthGate: FC<{ children: ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  return user ? <>{children}</> : <LoginPage />;
};

